export const queries = {
    baseURL: '/api/',
    login: 'auth/login',
    me: 'auth/me',
    logout: 'auth/logout',
    getCategories: 'categories',
}